import React from 'react';

export default function FooterCopyright() {
  return (
    <div className='footerContainer footerContainer--mod'>
     <span>© 2024 GBR Care</span> 
    </div>
  )
}
